import api from "../apis/index";

export const useApi = () => api;
